<template>
  <v-app v-if="authenticated">
    <Header
      :clipped="true"
      :drawer="false"
      :fixed="true"
      :title="title"
      ref="childComponent"
    />

    <v-content>
      <search-menu
        :showSearchMenu="showSM"
        :tab1="{ enabled: true, icon: 'fas fa-truck' }"
        :tab2="{ enabled: true, icon: 'fas fa-address-book' }"
        :tab3="{ enabled: true, icon: 'fas fa-book' }"
      />
      <router-view />
    </v-content>

    <VersionModal v-model="showVersionModal" />
  </v-app>
</template>

<script>
import Header from "./layout/header";
import searchMenu from "./components/searchMenuComponent.vue";
import VersionModal from "./components/VersionModal.vue";
import { initVersionCheck } from "./services/versionCheck";
export default {
  name: "App",
  components: { Header, searchMenu, VersionModal },

  data: () => ({
    title: process.env.VUE_APP_TITLE,
    authenticated: false,
    showVersionModal: false,
  }),

  computed: {
    showSM: function () {
      return this.$store.getters.GET_showSearchMenu.show;
    },  
  },

  async created() {
    await this.$GAUserAuth.refreshUserInfo().then((res) => {
      this.authenticated = this.$GAUserAuth.user.isAuthenticated;
    });

    this.title = process.env.VUE_APP_TITLE;
    if (window.location.host.indexOf("-test") > -1) this.title += " TEST";

    initVersionCheck(() => {
      this.showVersionModal = true;
    });
  },
};
</script>
<style scoped>
@import "./css/style.css";
</style>
